import { render, staticRenderFns } from "./archive-table-item.vue?vue&type=template&id=21506ce4&scoped=true"
import script from "./archive-table-item.vue?vue&type=script&lang=js"
export * from "./archive-table-item.vue?vue&type=script&lang=js"
import style0 from "./archive-table-item.vue?vue&type=style&index=0&id=21506ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21506ce4",
  null
  
)

export default component.exports